import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudReport = () => import('./staff/crudReport')
const ViewStaffCrudReportSeller = () => import('./staff/crudReportSeller')
const ViewStaffDetailReport = () => import('./staff/detailReport')
const ViewStaffCrudSurrender = () => import('./staff/crudSurrender')
const ViewStaffCrudSurrenderSeller = () => import('./staff/crudSurrenderSeller')
const ViewStaffMobileSurrenderCreate = () => import('./staff/mobileSurrenderCreate')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ReportsPaymentStaffDashboard',
  crudReport: 'ReportsPaymentStaffCrudReport',
  crudReportSeller: 'ReportsPaymentStaffCrudReportSeller',
  detailReport: 'ReportsPaymentStaffDetailReport',
  crudSurrender: 'ReportsPaymentStaffCrudSurrender',
  crudSurrenderSeller: 'ReportsPaymentStaffCrudSurrenderSeller',
  mobileSurrenderCreate: 'ReportsPaymentStaffMobileSurrenderCreate',
}

const router =
  [
    {
      path: '/st/reports-payment',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reporte de cobranzas',
          }           
        },  
        {
          path: 'crud',
          name: VIEWS.crudReport,
          component: ViewStaffCrudReport,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de reporte de cobranzas',
          }                     
        },  
        {
          path: 'crud/customers/:customersID',
          name: 'ReportsPaymentStaffCrudReportByCustomers',
          component: ViewStaffCrudReport,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de reporte de cobranzas desde clientes',
          }                     
        },           
        {
          path: 'crud-seller',
          name: VIEWS.crudReportSeller,
          component: ViewStaffCrudReportSeller,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de reporte de cobranzas',
          }                     
        },         
        {
          path: 'crud-seller/customers/:customersID',
          name: 'ReportsPaymentStaffCrudReportSellerByCustomers',
          component: ViewStaffCrudReportSeller,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de reporte de cobranzas desde clientes',
          }                  
        },          
        {
          path: 'detail/:reportID/view',
          name: VIEWS.detailReport,
          component: ViewStaffDetailReport,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Detalle de reporte de cobranzas',
          }        
        },          
        {
          path: 'crud-surrender',
          name: VIEWS.crudSurrender,
          component: ViewStaffCrudSurrender,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Rendiciones de cobranzas',
          }                  
        },
        {
          path: 'crud-surrender-seller',
          name: VIEWS.crudSurrenderSeller,
          component: ViewStaffCrudSurrenderSeller,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Rendiciones de cobranzas',
          }                         
        },
        {
          path: 'surrender-mobile/:surrenderId?',
          name: VIEWS.mobileSurrenderCreate,
          component: ViewStaffMobileSurrenderCreate,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Nueva Rendición de Cobranzas',
          }
        },
        {
          path: 'surrender-mobile/edit/:surrenderId',
          redirect: to => ({
            name: VIEWS.mobileSurrenderCreate,
            params: { surrenderId: to.params.surrenderId },
          }),
        },
      ]
    },

    {
      path: '/cu/reports-payment',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/reports-payment',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
